"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableCell_1 = require("./TableCell");
exports.default = TableCell_1.default;
//# sourceMappingURL=index.js.map